import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	rootContainer: {
		padding: `${theme.spacing(3)}px ${theme.spacing(5)}px`,
		backgroundColor: theme.palette.background.default
	},
	contactIcon: {
		marginTop: 3,
		marginRight: theme.spacing(1),
		color: theme.palette.primary.main
	},
	emailLink: {
		marginLeft: theme.spacing(1.5),
		marginRight: theme.spacing(1.5)
	},
	divider: {
		marginRight: theme.spacing(2)
	}
}));
